import { connect } from 'react-redux';

import LearningAdminModuleSeriesGridScreen from '../components/LearningAdminModuleSeriesGridScreen';
import storage from '../../../../../lib/Storage';

const moduleSerieTypes = [
  {
    action: 'recommended',
    value: true,
  },
  {
    action: 'recommended_not',
    value: false,
  },
];

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get('local', 'partnershipId');

  let total = 0;

  moduleSerieTypes.forEach((x) => {
    total +=
      state.learningsAdmin.getIn(
        [
          'moduleSeriesAdmin',
          partnershipId,
          x.action,
          'totalModuleSeriesAdmin',
        ],
        0
      ) || 0;
  });

  return {
    total,
    moduleSerieTypes: moduleSerieTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSeriesGridScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesGridScreen);

export default LearningAdminModuleSeriesGridScreenContainer;
